import React, { Component } from "react";
import Select from "react-select";
import { SkyLightStateless } from 'react-skylight';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import {
  Grid,
  Row,
  Col,
  Panel,
  Button,
  Tabs,
  Tab,
  ButtonToolbar,
  Breadcrumb,
  Dropdown,
  MenuItem,
  Input,
} from "react-bootstrap";
import { Translate } from "react-redux-i18n";
import { Toolbar, Data } from "react-data-grid-addons";
import ReactDataGrid from "react-data-grid";

import axios from 'axios';
import { ROOT_URL } from '../../../../actions/root_url';

// PUT--------    {{url}}v1/oversea-warehouse/change_location/37?location=222

export const updateLocation = (salesOrderId, location, success) => {
  axios({
    method: 'PUT',
    url: `${ROOT_URL}v1/oversea-warehouse/change_location/${salesOrderId}?location=${location}`,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
  })
  .then(res => {
    success();
  }, err => {
    alert(err.statusText);
  })
}


const modalStyle = {
  width: '500px',
  height: '300px',
  marginLeft: '-10%'
}

const propTypes = {
  selectedRows: PropTypes.array,
  onSuccess: PropTypes.func,
}

const defaultProps = {
  onSuccess: () => { },
  selectedRows: [],
}

class LocationChangeForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      location: props.selectedRows.length ? props.selectedRows[0].Location : '',
    };
  }

  componentDidUpdate(prevProps,prevState){
    if (prevProps.selectedRows[0] !== this.props.selectedRows[0]) {
      this.setState({
        location: this.props.selectedRows[0] ? this.props.selectedRows[0].Location : ''
      })
    }
  }

  handleConfirmClick = () => {
    const {
      selectedRows,
      onSuccess,
    } = this.props;
    const {
      location,
    } = this.state;
    updateLocation(selectedRows[0].SalesOrder_id, location, onSuccess);
  }

  render() {
    return (
      <div style={{ width: '100%', height: '100%', padding: '10px' }}>
        <h4>Location Change</h4>
        <div>
          <input
            type="text"
            style={{
              width: '200px',
              border: '1px solid black',
              padding: '2px',
              borderRadius: '5px',
              marginBottom: '10px',
            }}
            onChange={({ target }) => this.setState({
              location: target.value
            })}
            value={this.state.location}
          />
        </div>
        <Button
          bsStyle="primary"
          className="print-btn"
          type="button"
          // disabled={selectedRows.length !== 1}
          onClick={() => {
            this.handleConfirmClick();
          }}
        >
          {/* <em className="fa fa-pencil" /> */}
          <Translate value="confirm" />
        </Button>
      </div>
    )
  }
}

const LocationChange = ({ setModalVisibility, isVisible, onSuccess, selectedRows }) => (
  <SkyLightStateless
    title={'Edit Location'}
    onCloseClicked={setModalVisibility}
    dialogStyles={modalStyle}
    isVisible={isVisible}
  >
    <LocationChangeForm selectedRows={selectedRows} onSuccess={onSuccess} />
  </SkyLightStateless>
)

LocationChange.propTypes = propTypes
LocationChange.defaultProps = defaultProps

export default LocationChange;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/salesOrder/LocationChange.jsx